import React from 'react'
import { Box, Card, CardContent, Chip, Link, Typography, styled } from '@mui/material'
import { IconExternalLink } from '@tabler/icons-react'

const SectionCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
}))

interface Props {
  status: string | null
  createdAt: string | null
  updatedAt: string | null
  adAccountExternalId: string | null
  campaignExternalId: string | null
}

const ResultStep: React.FC<Props> = ({
  status,
  createdAt,
  updatedAt,
  adAccountExternalId,
  campaignExternalId,
}) => {
  const fbUrl =
    adAccountExternalId && campaignExternalId
      ? `https://adsmanager.facebook.com/adsmanager/manage/campaigns/edit/standalone?act=${adAccountExternalId}&selected_campaign_ids=${campaignExternalId}`
      : null

  const formatDate = (iso: string | null) => (iso ? new Date(iso).toLocaleString() : '–')

  const statusColor =
    status === 'published' ? 'success' : status === 'draft' ? 'warning' : 'default'

  return (
    <Box>
      <SectionCard>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="subtitle1" fontWeight={600} mb={2}>
            Result
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>
                Status
              </Typography>
              <Chip
                label={status || '–'}
                size="small"
                color={statusColor as any}
                variant="outlined"
              />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>
                Created
              </Typography>
              <Typography variant="body2">{formatDate(createdAt)}</Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>
                Last updated
              </Typography>
              <Typography variant="body2">{formatDate(updatedAt)}</Typography>
            </Box>

            {fbUrl && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>
                  Campaign link
                </Typography>
                <Link
                  href={fbUrl}
                  target="_blank"
                  rel="noopener"
                  sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                >
                  Open in Ads Manager
                  <IconExternalLink size={14} />
                </Link>
              </Box>
            )}

            {!fbUrl && (
              <Typography variant="body2" color="text.secondary">
                Campaign link will appear after successful publish.
              </Typography>
            )}
          </Box>
        </CardContent>
      </SectionCard>
    </Box>
  )
}

export default ResultStep
